import React, { useEffect, useState, useLayoutEffect } from 'react';
import CommunityImg from './../Common/CommunityImg/CommunityImg';
import Creative from './Creative/Creative';
import MediaPublication from './MediaPublication/MediaPublication';
import PartnerMural from '../../images/partner_page_mural.png';
import hand from '../../images/partner_mobile_hand.svg';
import handLeft from '../../images/Hand-left.svg';
import handRight from '../../images/Hand-right.svg';
import { useStaticQuery, graphql } from "gatsby"
import './PartnersProgramPage.scss';
import Accordion from './../Common/Accordion/Accordion';

const PartnersProgramPage = () => {

  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  const data = require('./frequentlyAskedQuestions.json');

  const {FaqData : {nodes : faqDataList}} =  data;

  useLayoutEffect(() => {
    function updateSize() {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth <= 1024);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = '#F7F1EC';
    return ()=>{
      document.body.style.backgroundColor = '';
    }
  }, [])

  const accordionData = [
    {
      title: 'What are the benefits of noissue’s Affiliate Programme?',
      content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.`
    },
    {
      title: 'What are the benefits of noissue’s Affiliate Programme?',
      content:  `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.`
    },
    {
      title: 'What are the benefits of noissue’s Affiliate Programme?',
      content:  `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.`
    }
  ];

  return (
    <div className="partner-page-container">
      <div className="partner-page-page">
        <div className="header-wrapper"
          style={ !isMobile || isTablet ?
            {
              backgroundImage : `url(${handLeft}), url(${handRight})`, 
              backgroundRepeat : 'no-repeat',
              backgroundPosition: 'left, right',
              paddingBottom: '35px',
              marginBottom: '30px',
              paddingTop: '80px',
              backgroundSize: isTablet ? `auto 170px` : `contain`
              } : {}
            }
          >
          <h1 className="heading"> noissue Partner Programs  </h1>
          <div className="sub-heading"> 
            Think your audience, clients, or community would be interested in sustainable, branded packaging? Join noissue’s partner program and receive commissions on all qualified orders. Applying just takes moments, and there is no cost to participate; get started today!
          </div>
          {
            isMobile && !isTablet &&
            <div className="image-container">
              <CommunityImg src={hand} alt="partner Page hand" />
            </div>
          }
        </div>
        <div className="partner-page-section">
          <MediaPublication />
        </div>
        <div className="partner-page-section">
          <Creative />
        </div>
        <div className="partner-page-accordion">
          <h2 className="heading">
            FAQs
          </h2>  
          {(faqDataList || []).map(({ faqQuestion, faqAnswer }) => (
            <Accordion 
              title={faqQuestion} 
              content={faqAnswer.raw} />
          ))}
        </div>
        <CommunityImg src={PartnerMural} className="partner-mural" />
      </div>
    </div>
  )
}

export default PartnersProgramPage; 
